module.exports = __webpack_public_path__ + "img/icon-circles.4907aac4.svg";